import axios from "axios";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let bearer = cookies.get("token");

export const requestHeader = {
  baseURL: "https://api.transportationprojects.org/api",
  headers: {
    Authorization: `Bearer ${bearer}`
  }
};
const instance = axios.create(requestHeader);

export default instance;
